module.exports = __webpack_public_path__ + "static/media/hide-wrinkles.fcea0346.svg";